module.exports = __webpack_public_path__ + "img/type999.2d326cad.png";